import "../assets/css/custom.css";
import "../assets/css/client.css";
import "../assets/css/font-awesome.css";
import "../assets/css/sweetalert.css";
import "../assets/css/bootstrap.min.css";
import "../assets/css/brand.css";
import { useEffect, useState } from "react";
import Modal from 'react-bootstrap/Modal';
import { commonAPI } from "../services/CommonAPIService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMotorcycle, faCar, faEdit, faL, faPlus, faSort, faTrash, faEllipsisVertical, faTrashCan, faPenToSquare, faPaperclip } from "@fortawesome/free-solid-svg-icons";
import Button from "react-bootstrap/Button";
import { ToastContainer, toast } from "react-toastify";
import FlatIcon from '../assets/img/config-flat.png';
import NoCompany from '../assets/img/comp.png';
import { useNavigate } from "react-router-dom";
import { FaChevronDown } from "react-icons/fa";
import {ErrorSource} from '../common/constants'
const Company = () => {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const [logo, setImageLogo] = useState()
  
  const [loading, setLoading] = useState(false)
  const [VehicleType, setVehicleType] = useState("4WHEELER")
  const [VehicleTypeBtnBike, setVehicleTypeBtnBike] = useState(false);
  const [VehicleTypeBtnCar, setVehicleTypeBtnCar] = useState(true);
  const [fileName, setFileName] = useState('');
  const [fileURL, setFileURL] = useState('');
  const [base64, setBase64] = useState('');
  const [deleteItem, setDeleteItem] = useState("")
  const [companyId,setCompanyId] = useState()
  const [brandName, setBrandName] = useState('')
  const category = ["CAB", "DELIVERY"]
  const [Selectcategory, setSelectCategory] = useState("")
  const [FilterCategory, setFilterCategory] = useState("")
  const [defaultCountryId, setSelectDefaultCountyId] = useState()
  const [seq, setSequence] = useState()
  const [popularBrand, setPopularBrand] = useState(true)
  const [imgSizeLarge, setImgSizeLarge] = useState(false)
  const [DeleteShow, setDeleteShow] = useState(false);
  const [ModalText, setModalText] = useState(false);
  const [updatedEdit, setUpdatedEdit] = useState(false)
  const [BuildingId, setBuildingId] = useState("")
  const [BuildingList, setBuildingList] = useState("")
  console.log("FilterCategory", FilterCategory)

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    const validImageTypes = ['image/jpeg', 'image/png', 'image/gif'];
    if (!/\.(jpeg|jpg|png)$/i.test(file?.name)) {
      toast.error("Please select an image in JPEG, JPG, or PNG format.");
    } else if (file?.size >= 50000) {
        toast.error("Please select a logo with a size below 50KB.");
    } else {
        const reader = new FileReader();

        reader.onload = () => {
            // atob(item?.logo)
            // console.log("base64======", reader.result)
            const SplitBase64 = reader.result.split("base64,");
            // console.log("SplitBase64======", SplitBase64[1])
            const encodedString = btoa(reader.result);
            setFileURL(reader.result);
            setBase64(reader.result)
          
        };
        reader.readAsDataURL(file);
    }
    // if (file.type == 'image/jpeg' || file.type == 'image/png' && file.size <= 5000) {
    //   setImgSizeLarge(false)
    //   const reader = new FileReader();
    //   reader.onload = function (e) {
    //     const imageUrl = e.target.result;
    //     console.log(imageUrl);
    //     setFileURL(imageUrl);
    //     console.log("Hjha")
    //     const myBase64Image = imageUrl
    //     setBase64(myBase64Image)
    //     console.log(myBase64Image[1])
    //   };
    //   reader.readAsDataURL(file);
    // }
    // else {
    //   setImgSizeLarge(true)
    //   toast.error("Please select a logo with a size below 50KB.");
    // }
    // console.log(event.target.files[0])
  }
  const openCreateModal = () => {
    if(!BuildingId){
      toast.warning("Please select Building");
    }else{  
      if(updatedEdit==true){
        setFileURL("")
      setBrandName("")
      setSelectCategory("")
      setShow(true)
      setModalText(true);
      setCompanyId("")
      setUpdatedEdit(false)
      }
      else{
        setShow(true)
      }
    }  
    // toast.warning("Please select building");

  };

  const GetBuildingList = async () => {
    const auth = localStorage.getItem("primeProductCode");
    const ProductfactorKey = JSON.parse(auth);
    const endPointVariableKey = {
        ProductId: ProductfactorKey?.primeProductCode,
    }
    try {
        // setLoading(true);
        let response = await commonAPI("BuildingLite", undefined, endPointVariableKey)
        if (response?.success===true){
            setBuildingList(response?.data);
            setLoading(false);
        }else{
            toast.error("Something went wrong");
            setLoading(false);
        }

    } catch (error) {
        console.log(error);
        setLoading(false);
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        const bodyError = { 
            "userId": myUserData?.userId,
            "mobileNumber": myUserData?.mobileNumber,
            "requestJSON": null,
            "uri": "/api/Master/Building",
            "errorNumber": "BL01",
            "errorSource": ErrorSource,
            "errorSummary": error?.message,
            "errorDescription": error?.message,
            "fileClassName": "flat.js",
            "functionName": "GetBuildingList",
        };
        let response = await commonAPI("ErrorLogMaster", bodyError);
        console.log("statusCode", response);
        if (response?.success == true && response?.message?.length == 0) {
            toast.error("Something went wrong");
            setLoading(false);
        } else {
            setLoading(false);
            toast.error("Something went wrong");
        }
    }

  } 

  useEffect(() => {
    GetBuildingList();

  }, []);

  useEffect(() => {        
    (async function(){
        const BuildingAuth = localStorage.getItem("BuildingId");
        const myBuildingId = JSON.parse(BuildingAuth);
        if(myBuildingId){
            setBuildingId(myBuildingId);
            console.log("building Id", myBuildingId)
        }    
    })()
}, [])

  useEffect(() => {
    if(BuildingId){
      fetchData();
      setImageLogo([]);
        (async function(){
            await localStorage.setItem("BuildingId", BuildingId);
        })()
    }else if (BuildingId == ""){
      setImageLogo([]);
      setFilterCategory("")
    }
}, [BuildingId])

  const fetchData = async () => {
    const auth = localStorage.getItem("userData");
    const myUserData = JSON.parse(auth);
    console.log(myUserData, "hshshshshsh")
    // setLoading(true);
    const endPointVariableKey = {
      buildingId: BuildingId,
    }
    setLoading(true)
    try {
      let response = await commonAPI("getCompanyLogo", undefined, endPointVariableKey);
      if (response?.success == true) {
        console.log("getCompanyLogo", response);
        const tempData = response?.data.filter((item) => item?.category.toUpperCase() == FilterCategory)
        console.log("tempDatagetCompanyLogo", tempData);
        setImageLogo(tempData)
        setLoading(false)
      }
      else {
        toast.warning("Something went wrong")
        setLoading(false)
      }

    } catch (error) {
      console.error("Error fetching vehicle logo:", error);
      setLoading(false)
    }
  };
  useEffect(() => {
    if(BuildingId){
      fetchData();
    }  

  }, [FilterCategory]);

  const VehicleCar = async () => {
    setVehicleTypeBtnCar(true)
    setVehicleTypeBtnBike(false)
    setVehicleType("4WHEELER")
  }
  const VehicleBike = async () => {
    setVehicleTypeBtnCar(false)
    setVehicleTypeBtnBike(true)
    setVehicleType("2WHEELER")
  }

  async function uploadLogo() {
    console.log(seq, "seq")
    console.log(brandName, "brand")
    if (!fileURL) {
      toast.warning("Please Upload Company Logo")
      return
    }
    else if (!brandName) {
      toast.warning("Please enter Company Name")
      return
    }
    else if (!Selectcategory) {
      toast.warning("Please select Category")
      return
    }
    const auth = localStorage.getItem("userData");
    const myUserData = JSON.parse(auth);
    const bodyReq = {
      "createdUserId": myUserData?.userId.toString(),
      "companyName": brandName,
      "category": Selectcategory,
      "logo": base64
    }
    const endPointVariableKey = {
      buildingId: BuildingId
    }
    console.log(bodyReq)
    setLoading(true)
    try {
      const response = await commonAPI("VisitorCompany", bodyReq, endPointVariableKey)
      if (response?.success == true) {
        setLoading(false)
        console.log(response)
        setShow(false)
        fetchData();
        toast.success("Company Added")
        setFilterCategory(Selectcategory)
        setBase64("");
        setBrandName("");
        setFileURL("")
      }
      else {
        toast.error(response?.message[0])
        setLoading(false)
      }

    }
    catch (error) {
      setLoading(false)
      console.log(error)
    }
  }
  async function DeleteCompanyLogo() {
    console.log(deleteItem, "DeleteItem")
    const auth = localStorage.getItem("userData");
    const myUserData = JSON.parse(auth);
    const endPointVariableKey = {
      buildingId: BuildingId
    }
    console.log(myUserData)
    const bodyReq = {
      "modifiedUserId": myUserData?.userId.toString(),
      "createdUserId": myUserData?.userId.toString(),
      "companyId": deleteItem,
    }
    console.log(bodyReq)
    try {
      const response = await commonAPI("delteCompanyLogo", bodyReq, endPointVariableKey)
      console.log(response, "RESPONSe")
      if (response?.success == true) {
        setLoading(false)
        setDeleteShow(false)
        fetchData();
        toast.success("Company Deleted")
        // navigate('/Configuration');
      }
      else {
        toast.warning(response?.message[0])
        setLoading(false)
      }

    }
    catch (error) {
      setLoading(false)
      console.log(error)
    }
  }

  function updateCompanyLogo(logo, companyName, category,companyId) {
    setUpdatedEdit(true)
    console.log(logo, companyName, category)
    setFileURL("data:image/png;base64," + logo)
    setBase64("data:image/png;base64," +logo)
    setBrandName(companyName)
    setSelectCategory(category)
    setShow(true)
    setCompanyId(companyId)
    setModalText(false);
  }


  async function performUpdate() {

    if (!fileURL) {
      toast.warning("Please Upload Company Logo")
      return
    }
    else if (!brandName) {
      toast.warning("Please enter Company Name")
      return
    }
    else if (!Selectcategory) {
      toast.warning("Please select Category")
      return
    }
    const auth = localStorage.getItem("userData");
    const myUserData = JSON.parse(auth);
    const bodyReq = {
      "companyName": brandName,
      "category": Selectcategory,
      "logo": base64,
      "modifiedUserId": myUserData?.userId.toString(),
      "createdUserId": myUserData?.userId.toString(),
      "companyId": companyId,
    }
    const endPointVariableKey = {
      buildingId: BuildingId
    }
    console.log(bodyReq)
    setLoading(true)
    try {
      const response = await commonAPI("updateCompanyLogo", bodyReq, endPointVariableKey)
      if (response.success == true) {
        setLoading(false)
        console.log(response)
        setShow(false)
        fetchData();
        toast.success("Company Updated")
        setFilterCategory(Selectcategory)
        setBase64("");
        setBrandName("");
        setFileURL("")
      }
      else {
        toast.warning(response?.message[0])
        setLoading(false)
      }

    }
    catch (error) {
      setLoading(false)
      console.log(error)
    }
  }


  return (<>
    {loading ?
      <div className="loaderDiv">
        <div className="loader"></div>
      </div>
      : null}
    <div className="row mt-5 pt-5 md-mb-3" style={{ alignItem: 'center' }}>
      <div className="col-lg-6 col-md-6">
        <div className="HeadingTop">
          <h3> Companies </h3>
          <span> Store and manage information about companies.</span>
        </div>
      </div>


      <div className="col-lg-6 col-md-6 mb-3 mb-md-0  text-right" style={{alignContent:'center'}}>
        <select size="md" className="sltareamodal col-3 ml-auto" value={BuildingId} onChange={(e) => {
            console.log("selection", e.target.value)
            setBuildingId(e.target.value); setFilterCategory("")}}>
            <option value="">Select Building</option>
            {BuildingList ? BuildingList?.map((item, index) =>  <option key={index} value={item?.buildingId}>{item?.buildingName}</option>): null}
        </select>
        <select size="md"  name="taskTypes" value={FilterCategory}   className="sltareamodal col-3 ml-auto"  onChange={(e) => { setFilterCategory(e.target.value); }}>
          {BuildingId ?
            <>
              <option  value="">
                Select Category
              </option>
              <option  value="CAB">
                CAB
              </option>
              <option value="DELIVERY">
                DELIVERY
              </option>
            </>
            :
            <option  value="">
              Select Category
            </option>
          }
        </select> 
        <Button variant="btn btn-info" onClick={() => openCreateModal()}>+ Create New </Button>{' '}
      </div>





      
    </div>

    <div className="row">
      {logo?.map((logoImg, index) => {
        return <div className="col-lg-3 col-md-6 col-sm-12 col-12" key={index}>
          <div className="clientTiles" style={{height:150}}>
              <div className="ClientImg">
                  <div className="tabs_img">
                  <img src={`data:image/jpeg;base64,${logoImg.logo}`} alt={`Logo ${index}`} class="img img-responsive" style={{width: "35px"}}/>
                  </div>
                  <div class="bars_font">
                      <h3 className="font_trigger"  onClick={() => { updateCompanyLogo(logoImg?.logo, logoImg?.companyName, logoImg?.category,logoImg?.companyId) }}>
                      <FontAwesomeIcon icon={faPenToSquare}  />
                      </h3>
                      <h3 className="font_trigger" onClick={() => { setDeleteShow(true); setDeleteItem(logoImg?.companyId) }}>
                        <FontAwesomeIcon icon={faTrashCan}  />
                      </h3>
                  </div>
              </div>
              <div className="ClientText">
                  <div className="l-two">
                      <h1> {logoImg?.companyName} </h1>
                      <h4>{logoImg?.category.toUpperCase() == "DELIVERY" ? "Delivery" : "Cab"} </h4>
                  </div>
              </div>
          </div>
      </div>
        // <div className="brandContainerChild" key={index}>
        //   <div>
        //     <img src={`data:image/jpeg;base64,${logoImg.logo}`} alt={`Logo ${index}`} />
        //     <label>{logoImg.companyName}</label>
        //   </div><div class="bars_font">
        //     <div style={{ display: "flex", position: "absolute", top: 0, gap: 10 }}>
        //       <FontAwesomeIcon icon={faPenToSquare} onClick={() => { updateCompanyLogo(logoImg.logo, logoImg.companyName, logoImg.category,logoImg.companyId) }} />
        //       <FontAwesomeIcon icon={faTrashCan} onClick={() => { setDeleteShow(true); setDeleteItem(logoImg.companyId) }} />
        //     </div>
        //   </div>
        // </div>
      })}

      {!logo ? (!logo?.length &&  logo?.length != null && 
      <div className='bg-white' style={{height: "400px", borderRadius: "10px"}}>
          <div className='col-12 text-center'>
              <img src={NoCompany} alt="user" class="mx-auto mt-5" style={{height: "150px"}} />
          </div>    
          <br />
          <h3 className='col-12 text-center' style={{marginTop: "0px"}}> No Company Found</h3>
          <h5 className='col-12 text-center' style={{marginTop: "10px"}}> Click on Create New button to add a Company</h5>
      </div>) :null}


    </div>
    <Modal size="md" show={show} onHide={() => setShow(false)} className="modal-100w modal-md clientmodal right text-end p-0" aria-labelledby="contained-modal-title-vcenter ">
      <Modal.Header closeButton className='headerMDL'>
        <Modal.Title id="contained-modal-title-vcenter" onClick={openCreateModal}>
          {ModalText ?  "Add Company" : "Update Company" }
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="helpingElelemnt_uuy002">


      <div className="container">
                      
                      <div className="row" id="validation">
                    <div className="col-12">
                       
                            
                         
                                <form action="#" className="validation-wizard wizard-circle wizard clearfix" role="application" id="steps-uid-2" novalidate="novalidate">
                                    
                                        <div className="content clearfix">
                                     
                                    
                                    <section id="steps-uid-2-p-0" role="tabpanel" aria-labelledby="steps-uid-2-h-0" className="body current pt-2" aria-hidden="false">
                                        <div className="row text-left">

                          <div className="col-md-12 mb-2 px-0">
                            {imgSizeLarge && <div className="imgSizeLine text-center small">Image Size is Exceeded </div>}
                            <div className="form-group parentUploadContainer">

                              

                            

                                <label for="wfirstName2" className='uploadcontainer' style={{width:"238px"}}> <FontAwesomeIcon icon={faPaperclip} />  &nbsp; Browse Company Logo  <span className="danger">*</span> 

          
                                <input type="file" onChange={(e) => { handleFileChange(e) }} value={''} className="form-control required" id="wfirstName2" name="firstName" aria-required="true" />
                                {fileURL && <img src={fileURL} alt="Selected" className="img-fluid" style={{ width: "100px" }} />}
                                
                                </label> 
                   
                            </div>
                           
                               <label className="text-danger mb-0"><span className="danger">*</span> Allowed File Types- JPEG/JPG/PNG.</label>
                            <br/>
                                <label className="text-danger mb-0"><span className="danger">*</span>Maximum image size - 50KB</label>
<br/><br/>

                            <div className="form-group">
                              <label for="wlastName2"> Company Name  <span className="danger">*</span> </label>
                              <input type="text" value={brandName} onChange={(e) => { setBrandName(e.target.value) }} className="form-control required" id="wlastName2" name="lastName" aria-required="true" /> </div>



                            <div className="form-group fixChevron mt-2">
                              <label >Category <span className="danger">*</span></label>
                              <select defaultValue={"Select Cateogory"} name="taskTypes" className="form-control" value={Selectcategory} onChange={(e) =>
                                setSelectCategory(e.target.value)}>
                                  <option value="" disabled>Select Category</option>
                                {category ? category?.map((item, index) => (
                                  <option key={index} value={item}> {item} </option>
                                ))
                                  : null}
                              </select>
                              <FaChevronDown className="absChevron" size={"10px"}/>   

                            </div>



                          </div>


                        </div>
</section>

                      </div>
 
                    </form>
                  
                </div>
              </div>
            
          </div> 
      </Modal.Body>
      <div className="fixed_allbtn">                        
              <div className="upload_btn"> 

                          <div className="  align-self-start">
                           

<div className="  align-self-start">
  <button type="button" className="btn border bg-white" onClick={() => setShow(false)}> Cancel</button>
  {/* <button type="button" className="btn btn-info" onClick={() => { uploadLogo() }}> Submit</button> */}
  {companyId ? <button type="button" className="btn btn-info" onClick={() => { performUpdate() }}> Update</button>: <button type="button" className="btn btn-info" onClick={() => { uploadLogo() }}> Submit</button>}
</div>
  
                          </div>

 
                                          </div>
 </div>

    </Modal>
    <Modal centered show={DeleteShow} onHide={() =>
      setDeleteShow(false)} dialogclassName="modal-100w" aria-labelledby="contained-modal-title-vcenter ">
      {/* <Modal.Header className="headerMDL" closeButton>
                    <Modal.Title id="contained-modal-title-vcenter" centered onClick={openCreateModal}>
                        <h4 className="mb-0"> Delete Tower </h4>
                    </Modal.Title>
                </Modal.Header> */}
      <Modal.Body className='p-0' style={{ borderRadius: "10px", overflow: "hidden" }}>
        <div className="row px-3" id="validation">
          <div className="col-12 bg-white pt-3 pb-2">
            <div className="FnFItem" style={{ justifyContent: "flex-start" }}>
              {/* <div className="FnFimg">
                                <img src={stopMark} className='img img-fluid img-responsive'  alt="placeholder" />
                            </div> */}
              <div className="FnFtxt">
                <h2> Delete Company  </h2>
                <h3> Are you sure you want to delete? </h3>
              </div>
            </div>

          </div>

        </div>
        <div className='confirmation_btn pb-4 pt-3 px-3' style={{ justifyContent: "center", borderTop: "1px solid #dadada" }}>
          <div className='both_ConfrmBTN col-6' onClick={() => DeleteCompanyLogo()}>
            <Button variant="danger">Delete</Button>{' '}
          </div>
          <div className='both_ConfrmBTN col-6' onClick={() => setDeleteShow(false)} >
            <Button variant="light"> Cancel</Button>{' '}
          </div>
        </div>
      </Modal.Body>
    </Modal>
    <ToastContainer />
  </>)
}
export default Company